import React, { Component } from 'react';
import Spinner from 'react-spinkit';

class MobileSliderElements extends Component {
	state = {
		loading: true,
		innerWidth: window.innerWidth
	};

	componentDidMount() {
		window.addEventListener('resize', this.updateWidth);
		this.resetState();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWidth);
	}

	updateWidth = () => {
		this.setState({
			innerWidth: window.innerWidth
		});
	};

	hideSpinner = () => {
		this.setState({
			loading: false
		});
	};

	resetState = () => {
		this.setState({
			loading: true
		});
	};

	stripIframe = (element) => {
		if (element) {
			let iframe = element;
			var src = iframe.split('src="')[1].split(/[ >]/)[0];
			src = src.slice(0, -1);
			return src;
		}
	};

	render() {
		if (this.state.innerWidth > 786) {
			return <div />;
		} else {
			return (
				<span>
					{this.props.thumbnailsArray[this.props.randomNum].randomAsset.includes('iframe') && (
						<span onLoad={(e) => this.resetState()}>
							{this.state.loading ? (
								<Spinner
									style={{ position: 'fixed', top: '50vh', left: '0', right: '0', margin: '0 auto' }}
									className="loading text-center"
									name="ball-clip-rotate"
									color="black"
									fadeIn="none"
								/>
							) : null}
							<iframe
								title={this.props.thumbnailsArray[this.props.randomNum].randomAsset}
								onLoad={this.hideSpinner}
								src={`${this.stripIframe(
									this.props.thumbnailsArray[this.props.randomNum].randomAsset
								)}?autoplay=1&mute=1&loop=1&controls=1"`}
							/>
						</span>
					)}
					{this.props.thumbnailsArray[this.props.randomNum].randomAsset.includes('mp4') && (
						<span onLoad={(e) => this.resetState()}>
							{this.state.loading === true ? (
								<Spinner
									style={{
										position: 'fixed',
										top: 'calc(50vh - 30px)',
										left: '0',
										right: '0',
										margin: '0 auto'
									}}
									className="loading text-center"
									name="ball-clip-rotate"
									color="black"
									fadeIn="none"
								/>
							) : null}
							<video
								src={this.props.thumbnailsArray[this.props.randomNum].randomAsset}
								autoPlay
								loop
								playsInline
								muted
								onLoad={this.hideSpinner}
							/>
						</span>
					)}
					{this.props.thumbnailsArray[this.props.randomNum].randomAsset.includes('mov') && (
						<span onLoad={(e) => this.resetState()}>
							{this.state.loading && (
								<Spinner
									style={{
										position: 'fixed',
										top: 'calc(50vh - 30px)',
										left: '0',
										right: '0',
										margin: '0 auto'
									}}
									className="loading text-center"
									name="ball-clip-rotate"
									color="black"
									fadeIn="none"
								/>
							)}
							<video
								src={this.props.thumbnailsArray[this.props.randomNum].randomAsset}
								autoPlay
								loop
								playsInline
								muted
								onLoad={this.hideSpinner}
							/>
						</span>
					)}
					{this.props.thumbnailsArray[this.props.randomNum].randomAsset.includes('images') && (
						<span onLoad={(e) => this.resetState()}>
							{this.state.loading ? (
								<Spinner
									style={{
										position: 'fixed',
										top: 'calc(50vh - 30px)',
										left: '0',
										right: '0',
										margin: '0 auto'
									}}
									className="loading text-center"
									name="ball-clip-rotate"
									color="black"
									fadeIn="none"
								/>
							) : null}
							<img
								onLoad={this.hideSpinner}
								alt="claire arnold project thumbnail"
								src={`${this.props.thumbnailsArray[this.props.randomNum].randomAsset}?w=500&fm=webp`}
							/>
						</span>
					)}
				</span>
			);
		}
	}
}

export default MobileSliderElements;



// WEBPACK FOOTER //
// ./src/Posts/elements/MobileSliderElements.js